<div class="cc-container">
    <div class="cc-header">
        <h3 class="d-flex"><span> Material Group</span>&nbsp; -&nbsp; Cost Contribution &nbsp;
            <div class="popover-icon" [popover]="rmPmPopOver" triggers="mouseenter:mouseleave" container="body"
                placement="bottom"><img src="../../assets/images/icn-info.svg" alt=""></div>
        </h3>
        <div class="header-toggle-div">
            <div class="toggle-box-div">
                <div class="toggle-left-div" [class.rm-select]="selectedMaterialType === 'rm'">
                    <mat-label (click)="toggleType('rm')" (keydown.enter)="toggleType('rm')"
                        (keydown.space)="toggleType('rm')">RM</mat-label>
                </div>
                <div class="toggle-right-div" [class.pm-select]="selectedMaterialType === 'pm'">
                    <mat-label (click)="toggleType('pm')" (keydown.enter)="toggleType('pm')"
                        (keydown.space)="toggleType('pm')">PM
                    </mat-label>
                </div>
            </div>

        </div>
        <mat-icon aria-hidden="false" aria-label="close icon" mat-dialog-close>close</mat-icon>
    </div>
    <div class="cc-body">
        <div class="cc-split">
            <div class="cc-graph-container">
                <div #donutDiv class="donut" id="donutDiv"></div>
                <div class="cc-graph-details">
                    <div class="cc-graph-details-title">{{hoveredTitle}}</div>
                    <div class="cc-graph-details-cost" *ngIf="hoveredCost" innerHTML="{{hoveredCost | cost}}">
                    </div>
                    <div class="cc-graph-details-percentage">{{hoveredPerc}}</div>
                </div>
            </div>
            <div class="cc-list-container">
                <div class="cc-search-container">
                    <input class="cc-text-box" (keyup)="searchRmOrPm($event.target.value)" matInput
                        [placeholder]="searchRmPmPlaceHolder" autocomplete="off" [value]="searchRmPmKeyword">
                </div>
                <div class="cc-list" (mouseleave)="hoveredPerc=''; hoveredTitle=''; hoveredCost=''">
                    <div class="cc-item" *ngFor="let item of filteredCostContributionRmPmItems; let i = index"
                        (mouseover)="hoveredPerc=item.percentage+'%'; hoveredTitle=item.name; hoveredCost=item.cost"
                        (focus)="hoveredPerc=item.percentage+'%'; hoveredTitle=item.name; hoveredCost=item.cost">
                        <div class="cc-left">
                            <div class="cc-color" [style.background-color]="item?.color"></div>
                            <div class="cc-name">
                                {{ (item?.name.length > 20)? (item?.name | slice:0:20)+'...' : (item?.name)}}
                            </div>
                        </div>
                        <div class="cc-right">
                            <div class="cc-percentage">{{item.percentage}}%</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #rmPmPopOver>
    <div class="mb-15-rm">Cost Contribution split at Material Group level for RM and PM at the {{data.level}} level
    </div>

    <div class="tooltip-formula-rm">
        <div class="tooltip-left-rm">
            Cost Contribution =
        </div>
        <div class="tooltip-center-rm">
            <div class="tooltip-center-top-rm">
                total waste cost generated by the selected Material Group(RM/PM)

            </div>
            <hr class="tooltip-center-middle-rm">
            <div class="tooltip-center-bottom-rm">
                total waste cost of RM/PM for the selected {{data.level}}
            </div>

        </div>
        <div class="tooltip-right-rm">
            * 100
        </div>
    </div>

</ng-template>